import { useCallback } from 'react';
import { useAuth, type PreferenciasAyuda } from '../hooks/useAuth';
import { useToast } from '../components/Toast';

export const MENSAJE_ERROR_PREFERENCIA = 'No se pudo guardar la preferencia de ayuda';

/**
 * Preferencias de ayuda interactiva del usuario actual. Sin usuario (o sin preferencias cargadas) la ayuda no se
 * muestra. Los cambios se ven enseguida; si no se pueden guardar, vuelven atrás y se avisa.
 */
export function usePreferenciasAyuda() {
  const { user, actualizarPreferencias } = useAuth();
  const toast = useToast();
  const activa = user?.ayudaInteractiva === true;
  const ocultas = user?.ayudaOcultas ?? [];

  const cambiar = useCallback(async (cambios: Partial<PreferenciasAyuda>) => {
    try { await actualizarPreferencias(cambios); }
    catch { toast.addToast(MENSAJE_ERROR_PREFERENCIA, 'error'); }
  }, [actualizarPreferencias, toast]);

  return {
    activa,
    ocultas,
    setActiva: (valor: boolean) => cambiar({ ayudaInteractiva: valor }),
    ocultarGuia: (id: string) => cambiar({ ayudaOcultas: [...ocultas.filter(g => g !== id), id] }),
    mostrarOcultas: () => cambiar({ ayudaOcultas: [] }),
  };
}
